<template>
  <b-col>
    <template v-if="!hideName">
      <b>{{name}}</b><br>
    </template>
    <span
      class="skill-tag mr-1 mt-1"
      :style="{ backgroundColor: backgroundColor || '#eee' }"
      v-for="skill in (value || [])"
      :key="skill"
    >{{skill}}</span>
  </b-col>
</template>

<script>
export default {
  name: 'JobSkillsShow',
  props: {
    name: {
      type: String,
      default: 'Skills',
    },
    value: {
      type: Array,
      default: () => [],
    },
    backgroundColor: {
      type: String,
      default: '#eee',
    },
    hideName: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.skill-tag {
  display: inline-block;
  font-size: 13px;
  padding: 3px 6px;
  border-radius: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/profile/JobSkillsShow.vue